import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { FieldValidationType } from '../../../../sic-lib/enums/FieldValidationType';
import { Contact } from '../../../../sic-lib/types/Contact';
import { ContactFieldValue } from '../../../../sic-lib/types/ContactField';
import MenuDefaultFieldActionsRaw from './MenuDefaultFieldActionsRaw/MenuDefaultlFieldActionsRaw';
import MenuEmailFieldActionsRaw from './MenuEmailFieldActionsRaw/MenuEmailFieldActionsRaw';
import MenuPhoneFieldActionsRaw from './MenuPhoneFieldActionsRaw/MenuPhoneFieldActionsRaw';

interface Props {
    fieldValue: ContactFieldValue;
    fieldIsPrimary: boolean;
    fieldIsReadOnly: boolean;
    fieldValidationType: FieldValidationType;
    fieldId: number;
    contact: Contact;
    onToggleHandler: () => void;
    onDeleteHandler: () => void;
}

export default function MenuContactFieldActions({
    fieldValidationType,
    fieldValue,
    fieldIsPrimary,
    fieldIsReadOnly,
    fieldId,
    contact,
    onToggleHandler,
    onDeleteHandler,
}: Props) {
    const menuId = `menu_${fieldValidationType.toString()}_field_${fieldId}`;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            {!fieldIsReadOnly && (
                <Box>
                    <IconButton
                        size="small"
                        aria-haspopup={true}
                        aria-controls={menuId}
                        onClick={handleOpen}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Box>
            )}
            {Boolean(anchorEl) && fieldValidationType === FieldValidationType.email && (
                <MenuEmailFieldActionsRaw
                    anchorEl={anchorEl}
                    menuId={menuId}
                    fieldIsPrimary={fieldIsPrimary}
                    onToggleHandler={onToggleHandler}
                    onDeleteHandler={onDeleteHandler}
                    onCloseHandler={handleClose}
                />
            )}
            {Boolean(anchorEl) && fieldValidationType === FieldValidationType.usMobilePhone && (
                <MenuPhoneFieldActionsRaw
                    anchorEl={anchorEl}
                    menuId={menuId}
                    contact={contact}
                    fieldValue={fieldValue as string}
                    fieldIsPrimary={fieldIsPrimary}
                    onToggleHandler={onToggleHandler}
                    onDeleteHandler={onDeleteHandler}
                    onCloseHandler={handleClose}
                />
            )}
            {Boolean(anchorEl) &&
                fieldValidationType !== FieldValidationType.usMobilePhone &&
                fieldValidationType !== FieldValidationType.email && (
                    <MenuDefaultFieldActionsRaw
                        anchorEl={anchorEl}
                        menuId={menuId}
                        fieldIsPrimary={fieldIsPrimary}
                        onToggleHandler={onToggleHandler}
                        onDeleteHandler={onDeleteHandler}
                        onCloseHandler={handleClose}
                    />
                )}
        </React.Fragment>
    );
}
